/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_Enable_LabelInputs */

const en_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable BWF Metadata`)
};

const fr_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les métadonnées BWF`)
};

const de_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWF-Metadaten aktivieren`)
};

const it_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita metadati BWF`)
};

const ru_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить метаданные BWF`)
};

const es_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar metadatos BWF`)
};

const zh_cn2_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 BWF 元数据`)
};

const ja_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWFメタデータを有効にする`)
};

const hi_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BWF मेटाडेटा सक्षम करें`)
};

const pt_pt2_audio_description_export_bwf_enable_label = /** @type {(inputs: Audio_Description_Export_Bwf_Enable_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar metadados BWF`)
};

/**
* | output |
* | --- |
* | "Enable BWF Metadata" |
*
* @param {Audio_Description_Export_Bwf_Enable_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_enable_label = /** @type {((inputs?: Audio_Description_Export_Bwf_Enable_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_Enable_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_bwf_enable_label(inputs)
	if (locale === "de") return de_audio_description_export_bwf_enable_label(inputs)
	if (locale === "it") return it_audio_description_export_bwf_enable_label(inputs)
	if (locale === "ru") return ru_audio_description_export_bwf_enable_label(inputs)
	if (locale === "es") return es_audio_description_export_bwf_enable_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_bwf_enable_label(inputs)
	if (locale === "ja") return ja_audio_description_export_bwf_enable_label(inputs)
	if (locale === "hi") return hi_audio_description_export_bwf_enable_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_bwf_enable_label(inputs)
	return en_audio_description_export_bwf_enable_label(inputs)
});